export function userHasCustomDocument(populationsIds: number[], population: number) {
    return populationsIds.length === 0 || populationsIds.includes(population);
}
